import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {
  onGetDegrees,
  onGetDepartmentsByFacultyId,
  onGetEmailTemplates,
  onGetFaculties,
  onGetProgramTypesByDegreeId,
  onGetSubDepartmentsByDepartmentId,
  onGetUniversities,
} from '../../../app/services/dataForComboBox/dataForComboBoxService'
import {onCreateEmail} from '../../../app/modules/send-email-system/components/email-creation/core/_requests'

interface SendEmailState {
  emailTemplates: any
  universities: any
  faculties: any
  departments: any
  degrees: any
  programTypes: any
  subDepartments: any
}

const initialState = {
  emailTemplates: [],
  universities: [],
  faculties: [],
  departments: [],
  subDepartments: [],
  degrees: [],
  programTypes: [],
} as SendEmailState

export const fetchEmailTemplates = createAsyncThunk('sendEmail/fetchEmailTemplates', async () => {
  const data: any = await onGetEmailTemplates()
  return data.data.result
})

export const fetchUniversities = createAsyncThunk('sendEmail/fetchUniversities', async () => {
  const data: any = await onGetUniversities()
  return data.data.result
})

export const fetchFaculties = createAsyncThunk('sendEmail/fetchFaculties', async () => {
  const data: any = await onGetFaculties()
  return data.data.result
})

export const fetchDepartments = createAsyncThunk(
  'sendEmail/fetchDepartments',
  async (param: any) => {
    const data: any = await onGetDepartmentsByFacultyId(param)
    return data.data.result
  }
)

export const fetchSubDepartments = createAsyncThunk(
  'sendEmail/fetchSubDepartments',
  async (param: any) => {
    const data: any = await onGetSubDepartmentsByDepartmentId(param)
    return data.data.result
  }
)

export const fetchDegrees = createAsyncThunk('sendEmail/fetchDegrees', async () => {
  const data: any = await onGetDegrees()
  return data.data.result
})

export const fetchProgramTypes = createAsyncThunk(
  'sendEmail/fetchProgramTypes',
  async (param: any) => {
    const data: any = await onGetProgramTypesByDegreeId(param)
    return data.data.result
  }
)

export const createEmail = createAsyncThunk('sendEmail/createEmail', async (param: any) => {
  const data: any = await onCreateEmail(param)
  return data.data
})

const sendEmailSlice = createSlice({
  name: 'sendEmail',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchUniversities.fulfilled, (state: any, action) => {
      state.universities = action.payload.items
    })
    builder.addCase(fetchFaculties.fulfilled, (state: any, action) => {
      state.faculties = action.payload.items
    })
    builder.addCase(fetchDepartments.fulfilled, (state: any, action) => {
      state.departments = action.payload.items
    })
    builder.addCase(fetchSubDepartments.fulfilled, (state: any, action) => {
      state.subDepartments = action.payload.items
    })
    builder.addCase(fetchDegrees.fulfilled, (state: any, action) => {
      state.degrees = action.payload.items
    })
    builder.addCase(fetchProgramTypes.fulfilled, (state: any, action) => {
      state.programTypes = action.payload.items
    })
    builder.addCase(fetchEmailTemplates.fulfilled, (state: any, action) => {
      state.emailTemplates = action.payload.items
    })
  },
})

export const {} = sendEmailSlice.actions

export default sendEmailSlice.reducer
